<template>
  <div class="fancy-hero-one">
    <div class="container">
      <div class="row">
        <div class="col-lg-9 m-auto">
          <h2 class="font-rubik">Transformer's Hub</h2>
          <p class="sub-heading">Sharing practical processes & technologies implemented to gain an innvovative and business advantage</p>
        </div>
      </div>
    </div>
    <div class="bubble-one"></div>
    <div class="bubble-two"></div>
    <div class="bubble-three"></div>
    <div class="bubble-four"></div>
    <div class="bubble-five"></div>
    <div class="bubble-six"></div>
  </div>
</template>

<script>
export default {
  methods: {
    onSubmit() {
    },
  },
}
</script>